import React from 'react';
import Icon from '../../../components/AppIcon';

const LeadPipeline = ({ stats = {} }) => {
  const pipelineStages = [
    {
      key: 'new',
      label: 'New Leads',
      icon: 'UserPlus',
      color: 'bg-blue-500',
      bgColor: 'bg-blue-50 dark:bg-blue-950',
      textColor: 'text-blue-700 dark:text-blue-300'
    },
    {
      key: 'contacted',
      label: 'Contacted',
      icon: 'Phone',
      color: 'bg-orange-500',
      bgColor: 'bg-orange-50 dark:bg-orange-950',
      textColor: 'text-orange-700 dark:text-orange-300'
    },
    {
      key: 'validated',
      label: 'Validated',
      icon: 'CheckCircle',
      color: 'bg-green-500',
      bgColor: 'bg-green-50 dark:bg-green-950',
      textColor: 'text-green-700 dark:text-green-300'
    },
    {
      key: 'shortlisted',
      label: 'Shortlisted',
      icon: 'Star',
      color: 'bg-purple-500',
      bgColor: 'bg-purple-50 dark:bg-purple-950',
      textColor: 'text-purple-700 dark:text-purple-300'
    },
    {
      key: 'sent_to_client',
      label: 'Sent to Client',
      icon: 'Send',
      color: 'bg-indigo-500',
      bgColor: 'bg-indigo-50 dark:bg-indigo-950',
      textColor: 'text-indigo-700 dark:text-indigo-300'
    },
    {
      key: 'placed',
      label: 'Placed',
      icon: 'Trophy',
      color: 'bg-emerald-500',
      bgColor: 'bg-emerald-50 dark:bg-emerald-950',
      textColor: 'text-emerald-700 dark:text-emerald-300'
    }
  ];

  const totalLeads = Object.values(stats).reduce((sum, count) => sum + (count || 0), 0) - (stats.rejected || 0);
  const placementRate = totalLeads > 0 ? ((stats.placed || 0) / totalLeads * 100).toFixed(1) : 0;

  return (
    <div className="bg-card border border-border rounded-lg p-4 sm:p-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6">
        <div>
          <h2 className="text-xl font-semibold text-foreground">Lead Pipeline</h2>
          <p className="text-sm text-muted-foreground mt-1">
            Track leads through the placement process
          </p>
        </div>
        
        <div className="flex items-center gap-6 mt-4 sm:mt-0">
          <div className="text-center">
            <p className="text-2xl font-bold text-foreground">{totalLeads}</p>
            <p className="text-xs text-muted-foreground">Total Active</p>
          </div>
          <div className="text-center">
            <p className="text-2xl font-bold text-emerald-600">{placementRate}%</p>
            <p className="text-xs text-muted-foreground">Placement Rate</p>
          </div>
          {stats.rejected > 0 && (
            <div className="text-center">
              <p className="text-2xl font-bold text-red-600">{stats.rejected}</p>
              <p className="text-xs text-muted-foreground">Rejected</p>
            </div>
          )}
        </div>
      </div>

      {/* Pipeline Stages */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-4">
        {pipelineStages.map((stage, index) => {
          const count = stats[stage.key] || 0;
          const percentage = totalLeads > 0 ? (count / totalLeads * 100).toFixed(0) : 0;

          return (
            <div key={stage.key} className="relative">
              {/* Connection Line - Hidden on mobile */}
              {index < pipelineStages.length - 1 && (
                <div className="hidden lg:block absolute top-8 -right-2 w-4 h-0.5 bg-border z-0" />
              )}

              <div className={`${stage.bgColor} p-3 sm:p-4 rounded-lg border border-border relative z-10`}>
                <div className="flex items-center justify-between mb-2">
                  <div className={`p-1.5 rounded-md ${stage.color}`}>
                    <Icon name={stage.icon} size={14} color="white" />
                  </div>
                  <span className="text-xs text-muted-foreground">{percentage}%</span>
                </div>
                
                <div>
                  <p className="text-xl sm:text-2xl font-bold text-foreground">{count}</p>
                  <p className={`text-xs sm:text-sm font-medium ${stage.textColor} mt-1 leading-tight`}>
                    {stage.label}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Pipeline Flow - Mobile View */}
      <div className="lg:hidden mt-4 flex justify-center">
        <div className="flex items-center gap-2">
          {pipelineStages.slice(0, -1).map((stage, index) => (
            <React.Fragment key={stage.key}>
              <div className={`w-2 h-2 rounded-full ${stage.color}`} />
              <Icon name="ChevronRight" size={12} className="text-muted-foreground" />
            </React.Fragment>
          ))}
          <div className={`w-2 h-2 rounded-full ${pipelineStages[pipelineStages.length - 1].color}`} />
        </div>
      </div>
    </div>
  );
};

export default LeadPipeline;